import { render, staticRenderFns } from "./VideoRedirectUrl.vue?vue&type=template&id=1c7bc124"
import script from "./VideoRedirectUrl.vue?vue&type=script&lang=js"
export * from "./VideoRedirectUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports